import React, { useEffect, useState } from "react";
import "./About.css";


function About() {
  const [projects, setProjects] = useState(0);
  const [experience, setExperience] = useState(0);
  const [clients, setClients] = useState(0);

  // =========================================
  // DYNAMIC ABOUT IMAGES
  // =========================================
  const aboutImages = [
    "/About/img (1).jpg",
    "/About/img (1).png",
    "/About/img (2).jpg",
    "/About/img (2).png",
    "/About/img (3).jpg",
    "/About/img (3).png",
    "/About/img (4).jpg",
    "/About/img (4).png",
    "/About/img (5).jpg",
    "/About/img (5).png",
    "/About/img (6).jpg",
    "/About/img (6).png",
    "/About/img (7).jpg",





  ];

  const [imageIndex, setImageIndex] = useState(0);

  // =========================================
  // AUTO IMAGE CHANGE
  // =========================================
  useEffect(() => {
    const imageInterval = setInterval(() => {
      setImageIndex((prevIndex) =>
        (prevIndex + 1) % aboutImages.length
      );
    }, 3500); // 3.5 seconds

    return () => clearInterval(imageInterval);
  }, [aboutImages.length]);

useEffect(() => {
  let p = 0;
  let e = 0;
  let c = 0;

  const interval = setInterval(() => {
    if (p < 50) {
      p++;
      setProjects(p);
    }

    if (e < 5) {
      e++;
      setExperience(e);
    }

    if (c < 30) {
      c++;
      setClients(c);
    }

    // Stop only when all targets are reached
    if (p >= 50 && e >= 5 && c >= 30) {
      clearInterval(interval);
    }
  }, 70);

  return () => clearInterval(interval);
}, []);

  return (
    <section className="about-section" id="about">

      {/* BACKGROUND */}

      <div className="about-noise"></div>

      <div className="about-blur about-blur1"></div>
      <div className="about-blur about-blur2"></div>

      <div className="about-container">

        {/* HEADER */}

        <div className="about-header">

          <div className="about-tag">
            <span></span>
            OUR CULTURE
            <span></span>
          </div>

          <h2 className="about-heading">
            Curious Minds.
            <br />
            <em>Creative Humans.</em>
            <br />
            Culture Makers.
          </h2>

          {/* CULTURE BANNER */}
          <div className="culture-banner">
            <img
              src="/About/AboutBanner.png"
              alt="Behind the scenes at The Culture Capsule"
            />

            <div className="culture-banner-overlay"></div>

            <div className="culture-banner-content">
              <span>BEHIND THE SCENES</span>
              <span>THE CULTURE CAPSULE</span>
            </div>
          </div>

          <p className="about-subtitle">
            We don't just build brands.
            <br />
            We build the stories people remember.
          </p>

        </div>


        {/* MAIN STORY */}
        <div className="about-top">

          {/* =========================================
              DYNAMIC IMAGE SLIDER
              ========================================= */}

          <div className="about-image-wrapper">

            <div className="about-image">

              {aboutImages.map((image, index) => (
                <img
                  key={image}
                  src={image}
                  alt={`The Culture Capsule ${index + 1}`}
                  className={`about-slide ${index === imageIndex ? "active" : ""
                    }`}
                />
              ))}

              <div className="image-overlay"></div>

              <div className="image-caption">
                <span>THE CULTURE CAPSULE</span>

                <span>
                  {String(imageIndex + 1).padStart(2, "0")} /{" "}
                  {String(aboutImages.length).padStart(2, "0")}
                </span>
              </div>

              {/* SLIDER DOTS */}

              <div className="about-dots">
                {aboutImages.map((_, index) => (
                  <span
                    key={index}
                    className={index === imageIndex ? "active" : ""}
                  ></span>
                ))}
              </div>

            </div>

            <div className="image-number">
              01
            </div>

          </div>
          {/* CONTENT */}

          <div className="about-content">

            <div className="about-kicker">
              <span>WHO WE ARE</span>
              <div></div>
            </div>

            <div className="about-text">

              <p className="about-lead">
                Who doesn't want their brand to become
                the topic of a chai break?
              </p>

              <p>
                Or the story someone can't stop sharing
                over coffee?
              </p>

              <p>
                The tricky part is that culture can't be
                forced into a campaign. It has to earn its
                place in conversations.
              </p>

              <p>
                That's why every project at The Culture
                Capsule starts with a kettle on, coffee
                brewing, and a room full of opinions.
              </p>

              <p>
                We question, debate, disagree, laugh,
                and somewhere between the chai refills
                and coffee breaks, the right idea finds us.
              </p>

              <p className="about-highlight">
                Turns out healthy debates are a thing. Our HR is half-bored, half-sleepy all the time. No office drama makes for a dull HR department. Somehow I have found my space here, at TCC, in italics. I am just a copy intern here, but my voice is valued, as you can see (or read), in italics.
              </p>

              <p>
                Whether it's building bold identities, crafting cinematic stories, climbing search rankings, or driving real growth, we believe the best ideas are brewed before they're built. The strangest part of working here? Even the intern's idea can derail an entire brainstorming session. And then by the end of it, you won’t know if it was the CCO’s idea, or mine. He is also a copywriter by the way. I am just better. He also agrees. We're pretty good at blending things. Just not chai with coffee. Chai lattes aren't our thing. We blend creativity with technology, strategy with storytelling, art with analytics, emotions with execution… and brands with culture.
              </p>

            </div>

          </div>

        </div>


        {/* STATS */}

        <div className="about-stats">

          <div className="stat-card">

            <div className="stat-top">
              <span>01</span>
              <span>+</span>
            </div>

            <h3>{projects}</h3>

            <p>
              Projects Completed
            </p>

            <div className="stat-line"></div>

          </div>


          <div className="stat-card">

            <div className="stat-top">
              <span>02</span>
              <span>+</span>
            </div>

            <h3>{experience}</h3>

            <p>
              Years of Experience
            </p>

            <div className="stat-line"></div>

          </div>


          <div className="stat-card">

            <div className="stat-top">
              <span>03</span>
              <span>+</span>
            </div>

            <h3>{clients}</h3>

            <p>
              Brands & Clients
            </p>

            <div className="stat-line"></div>

          </div>

        </div>


        {/* BOTTOM STATEMENT */}

        <div className="about-bottom">

          <div className="about-bottom-line"></div>

          <p>
            WE THINK.
            <span> WE CREATE.</span>
            <span> WE MAKE BRANDS MATTER.</span>
          </p>

          <div className="about-bottom-line"></div>

        </div>

      </div>

    </section>
  );
}

export default About;